import { container } from '@shared/common/dependency-injection/domain/container';
import { LandingModuleRoutes } from '@shared/feature/landing/application/routes/landing.module-routes';

export const landingRoutes = new LandingModuleRoutes(container).getRoutes();
